import { checkAppVersion } from "./utils";
import { handleAuthStatus, TOKEN_STORAGE_KEY } from "../utils/authSession";

/**
 * Default headers (JSON + bearer token) with the caller's own headers layered on top.
 * A caller that sets `Authorization` itself (the login call sends an empty one) wins.
 */
export const createHeadersFormOptions = (options = {}) => {
  const token = localStorage.getItem(TOKEN_STORAGE_KEY);
  const requestHeaders = new Headers({
    Accept: "application/json",
    Authorization: token ? `Bearer ${token}` : "",
  });
  new Headers(options.headers || {}).forEach((value, key) => {
    requestHeaders.set(key, value);
  });

  if (
    !requestHeaders.has("Content-Type") &&
    !(options && (!options.method || options.method === "GET")) &&
    !(options && options.body && options.body instanceof FormData)
  ) {
    requestHeaders.set("Content-Type", "application/json");
  }

  return requestHeaders;
};

export const fetchJson = async (url, options = {}) => {
  const requestHeaders = createHeadersFormOptions(options);

  return fetch(url, { ...options, headers: requestHeaders })
    .then((response) =>
      response.text().then((text) => ({
        status: response.status,
        statusText: response.statusText,
        headers: response.headers,
        body: text,
      })),
    )
    .then(({ status, headers, body }) => {
      checkAppVersion(headers.get("x-version"));
      handleAuthStatus(status);

      return Promise.resolve({ status, headers, body, json: JSON.parse(body) });
    });
};
